angular.module('am4').directive('resultsList', () => {
    return {
        restrict: 'E',
        template: require('../views/dashboard/results.html')
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/resultsList.js